module.exports = __webpack_public_path__ + "static/media/Poppins-Black.1baded66.ttf";